// set basepath of project for webpack
import { basePath } from './core/config'
__webpack_public_path__ = `${basePath}/assets/frontend/js/`

import './core/Sentry'

import { android, iOS, CMS } from './core/config'
function isNativeScroll() {
	return android || iOS || CMS || (typeof DISABLE_SMOOTH_SCROLL !== 'undefined' && DISABLE_SMOOTH_SCROLL) || document.body.classList.contains('u-nativeScroll')
}

// nette
import './nette/NetteAutosubmit'
import './nette/NetteValidationMessages'
import Nette from './nette/NetteForms'
window.Nette = Nette
Nette.initOnLoad()

import NajaService from './services/Naja'
NajaService.formsHandler.netteForms = Nette
NajaService.initialize()

import TouchMouseInputResolver from './meta/TouchMouseInputResolver'
new TouchMouseInputResolver()

import ScrollService, { setScrollPosition, scrollToElement } from './services/Scroll'
if (isNativeScroll()) {
    ScrollService.useNative()
    setScrollPosition()
} else {
    ScrollService.useVirtual()
        .catch(() => ScrollService.useNative())
        .finally(() => setScrollPosition())
}

import { loadComponents, removeComponents } from './core/componentUtils'
loadComponents()

import { runLazyImages } from './services/LazyImages'
runLazyImages()

import { scrollHistory } from './services/ScrollHistory'
import { runSwup } from './services/Swup'
import EventBus from './core/EventBus'
import { EVENTS } from './core/Events'
import { runScriptsInsideElement } from './utils/script'

runSwup({
	Nette,
	ScrollService,
	EventBus,
	EVENTS,
	scrollToElement,
	loadComponents,
	removeComponents,
	scrollHistory,
    setScrollPosition,
	runScriptsInsideElement,
	isNativeScroll,
	NajaService,
})